export function detectIOsMob() {
    const toMatch = [
        /iPhone/i,
        /iPad/i,
        /iPod/i
    ];

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
}

export function detectIOsMobile() {
    return navigator.userAgent.match(/HSPORTALAPP/i);
}
